import { __awaiter } from "tslib";
function run() {
    return __awaiter(this, void 0, void 0, function* () {
        // const $btns = $('.buy-product-btn').toArray().map(e => $(e))
        // $btns.map($btn => {
        // 	const product = $btn.attr('product')!
        // 	$btn.on('click', (e) => {
        // 		api.post('/buy', { product: Number(product) }).then((res) => {
        // 			console.log('res', res)
        // 			if (res.href) {
        // 				window.open(res.href, '_blank').focus()
        // 			}
        // 		}).catch(err => {
        // 			modalService.error(err)
        // 			console.error(err)
        // 		})
        // 	})
        // })
    });
}
export const page_sub = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=subscriptions.js.map